import { useParams } from 'react-router-dom'

import moment from 'moment'

import NotFound from 'modules/core/components/NotFound'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import ClockInStore from 'modules/attendance/components/ClockIn/Store'
import TabsBreakdown from 'modules/attendance/components/ClockIn/TabsBreakdown'
import type { StoreProps } from 'modules/attendance/components/ClockIn/types'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'
import { SidePanelTab } from 'modules/attendance/lib/sidepanelTabTypes'
import { TimeSettingsCategoryProvider } from 'modules/attendance/lib/timeSettingsCategoryContext'

type Props = {
  tabFromNavigation: SidePanelTab
}

const SidePanelPage = ({ tabFromNavigation }: Props) => {
  const { employee } = useCurrentSession()
  const { dateFrom, dateTo } = useAttendanceDateNavigator()
  const { month, year, day, employeeId } = useParams()

  const coercedProps: StoreProps = {
    year: Number(year),
    month: Number(month),
    employeeId: Number(employeeId),
    layout: 'employee',
    currentEmployeeId: employee?.id,
  }
  const periodStartOn = moment([Number(year), Number(month) - 1, Number(day)])
  // TODO: remove this store after having estimated times on graphql
  const store = new ClockInStore(coercedProps)

  useAsyncData(async () => {
    if (store.currentPeriod) return
    await store.fetch(moment(dateFrom), moment(dateTo))
  }, [month, year, day])

  const missingParam = !month || !year || !day || !employeeId

  if (missingParam) return <NotFound />

  return (
    <TimeSettingsCategoryProvider>
      <TabsBreakdown
        tabFromNavigation={tabFromNavigation}
        employeeId={Number(employeeId)}
        timeSheetDate={periodStartOn}
        store={store}
      />
    </TimeSettingsCategoryProvider>
  )
}

export default SidePanelPage
